import { notification } from 'antd';
import axios from 'axios';
import { getApplicationIdByReg } from '.';
import { lockify } from 'fn.locky';
import { host } from './env';
import { login } from '@/components/Auth/login';
type Response<T = any> = {
  success: boolean;
  data?: T;
  msg?: string;
};

declare module 'axios' {
  interface AxiosInstance {
    <T>(config: AxiosRequestConfig): Promise<Response<T>>;
  }
}

const service = axios.create({
  timeout: 10000,
  withCredentials: true,
});
service.interceptors.request.use(
  (config) => {
    // 所有充电供给的接口都要带上applicationId字段参数
    if (config.url?.includes('/operatorplatform')) {
      const applicationId = getApplicationIdByReg();
      if (config.method === 'get') {
        config.params.applicationId =
          config.params.applicationId || applicationId;
      } else if (config.method === 'post') {
        config.params = {
          applicationId: config.data.applicationId || applicationId,
        };
      }
    }
    return config;
  },
  (error) => console.log('request===', error),
);

service.interceptors.response.use(
  (response) => {
    const isInAdmin = location.href.includes('/admin');
    const { message, msg, success, module, data, code, status }: any = response.data;
    let suce = success ?? code === 10000;
    if (!suce) {

      if (status === 10008) {
        if (isInAdmin) {
          login();
        }
      }

      if (isInAdmin) {
        notification.error({
          message: '网络请求失败',
          description: message ?? msg ?? '网络错误',
        });
      }
      return Promise.reject({ success: false });
    }
    
    return {
      success: suce,
      data: module ?? data,
      msg: message ?? msg ?? '网络错误',
    };
  },
  (error) => {
    notification.error({
      message: '网络请求异常，请稍后重试',
      description: error.toString(),
    });
    // return { success: false };
    return Promise.reject({ success: false });
  },
);

async function request<T>(url, data, options, method) {
  return service<T>({
    url,
    method,
    baseURL: host,
    ...data,
    ...options,
  })
    .then((res) => {
      const { data, success, msg } = res;
      return { data, success, msg };
    });
}

async function get<T>(url, params = {}, options = {}) {
  return request<T>(url, { params }, options, 'GET');
}

async function post<T>(url, params = {}, options = {}) {
  return request<T>(url, { data: params }, options, 'POST');
}

export default { get, post };
